export default async function svgToPngUsingImg(svgElement, width, height) {
  // 1. Serialize SVG

  const serializer = new XMLSerializer();
  let svgString = serializer.serializeToString(svgElement);

  // 2. Ensure the SVG has the XML namespace
  if (!svgString.includes('xmlns="http://www.w3.org/2000/svg"')) {
    svgString = svgString.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
  }

  // 3. Encode SVG string to base64
  const svgBase64 = btoa(unescape(encodeURIComponent(svgString)));;
  const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;

  // 4. Create and load <img> element
  const img = new Image();
  img.src = svgDataUrl;

  await img.decode(); // Wait for image to be fully loaded

  // 5. Draw onto OffscreenCanvas
  const offscreenCanvas = new OffscreenCanvas(width, height);
  const ctx = offscreenCanvas.getContext('2d');

  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  // 6. Export PNG blob
  const pngBlob = await offscreenCanvas.convertToBlob({ type: 'image/png' });

  return pngBlob;
}

export function blobToBase64URL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result); // This will be the base64 URL
    };

    reader.onerror = reject;

    reader.readAsDataURL(blob);
  });
}
